import { magellanClient } from '../../../infra/axios';
import type {
  CreateBidResponseTagRequestDTO,
  CreateBidResponseTagResponseDTO,
} from './dto';

export async function createBidResponseTags(
  {
    bidResponseId,
    propertyId,
  }: {
    bidResponseId: number;
    propertyId: number;
  },
  payload: CreateBidResponseTagRequestDTO,
): Promise<CreateBidResponseTagResponseDTO> {
  const response = await magellanClient.post<CreateBidResponseTagResponseDTO>(
    `/bidResponses/${bidResponseId}/vaultProperties/${propertyId}/bidResponseTags`,
    payload,
  );

  return response.data;
}

export async function deleteBidResponseTag({
  bidResponseId,
  propertyId,
  tagId,
}: {
  bidResponseId: number;
  propertyId: number;
  tagId: number;
}): Promise<void> {
  await magellanClient.delete(
    `/bidResponses/${bidResponseId}/vaultProperties/${propertyId}/bidResponseTags/${tagId}`,
  );
}
